import useClientMutation from '../../common/useClientMutation';
import { ALERTS_REGISTERED_URL } from '../../consts';
export default function useUserAlertsRegistration(props) {
    return useClientMutation({
        cacheKey: 'userAlertsRegistration',
        url: ALERTS_REGISTERED_URL,
        fetchOptions: {
            method: 'GET'
        },
        clientOptions: {
            useErrorBoundary: false,
            cacheTime: 0,
            retry: false,
            onSuccess: props?.onSuccess,
            onError: props?.onError
        }
    });
}

//# sourceMappingURL=useUserAlertsRegistration.js.map